import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export const useInMemoryStore = create(
  devtools(
    combine(
      {
        isShowingTaskableTextButton: false,
        isPlacingDeskNode: false,
        autofocusNodeId: null as string | null,
        highlightCommentId: null as string | null,
      },
      (set) => ({
        setIsShowingTaskableTextButton: (isShowing: boolean) =>
          set({ isShowingTaskableTextButton: isShowing }),
        setIsPlacingDeskNode: (isPlacing: boolean) =>
          set({ isPlacingDeskNode: isPlacing }),
        setAutofocusNodeId: (autofocusNodeId: string | null) =>
          set({ autofocusNodeId }),
        setHighlightCommentId: (highlightCommentId: string | null) =>
          set({ highlightCommentId }),
      })
    )
  )
)
